module.exports = __webpack_public_path__ + "media/images/recruitment/designs/alpha-phi-design-ec2305342b0f7432106f7a356802808a.svg";